import React from "react";
import { ASPECT_BOX } from "../../hooks/useVideoStudio";

export const Frame = ({ aspect, children }) => (
  <div className={`flex justify-center ${aspect === "9:16" ? "h-[min(56vh,460px)]" : ""}`}>
    <div className={`${ASPECT_BOX[aspect] || ASPECT_BOX["16:9"]} relative rounded-lg overflow-hidden bg-black flex items-center justify-center`}>
      {children}
    </div>
  </div>
);

export default Frame;
